import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { createTripToJson } from '../resolvers/create-trip-to-json.resolver'
import { createdTripResolver } from '../resolvers/created-trip.resolver'
import { CreateTripResponse } from '../types/api-responses/create-trip-response'
import { BookFormModel } from '../types/models/book-form.model'
import { CreateTripModel } from '../types/models/create-trip.model'

type Input = BookFormModel & CreateTripModel

export function createAddTripUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (trip: Input) {
    const { token, accountType } = await tokenService.getToken()
    const authHeaders = token ? AUTH_HEADER(token) : {}
    const req = createTripToJson(trip)
    const res = await httpClient
      .version('v1')
      .addHeaders(authHeaders)
      .post<{ data: CreateTripResponse }>(`/website/${accountType}/trips`, req)
    return createdTripResolver(res.data.data)
  }
}
